import { render, staticRenderFns } from "./OfferCard.vue?vue&type=template&id=3cd54397&scoped=true&"
import script from "./OfferCard.vue?vue&type=script&lang=js&"
export * from "./OfferCard.vue?vue&type=script&lang=js&"
import style0 from "./OfferCard.vue?vue&type=style&index=0&id=3cd54397&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd54397",
  null
  
)

export default component.exports